
$models.permissions = {
	
	getItem : function($itemid, $callback) {
		$models.permissions.getList({}, $callback);
	},
	
	getList : function($params, $callback) {
		if ($models.permissions.currentGetListAjaxRequest) {
			$models.permissions.currentGetListAjaxRequest.abort();
		}
		$models.permissions.currentGetListAjaxRequest = $models.all.getDataFromAPI('permissions.json', '', $callback, 'Unable to retrieve list of permissions for this team.');
	},
	
	getListWithOffset : function($params, $callback) {
		$params = ($params || {});
		$models.permissions.getList($params, $callback);
	},
	
	getSize : function($callback) {
		$models.permissions.getList({}, function($data) {
			$callback($data.permissions.length);
		});
	},
	
	setItem : function($formData, $callback) {
		$models.all.getDataFromAPI('permissions.json', $formData, $callback, 'An error occurred whilst saving your team permissions', 'PUT', 'generic', 'false', 'application/json');
	},
	
	deleteItem : function($callback) {
		$soupmail.modal.error('Attempted to delete permissions.  Not implemented at this time.');
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.permissions.currentGetListAjaxRequest) { return false; }
		if ($models.permissions.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}
	
};



// WEBPACK FOOTER //
// ./src/js/models/permissions.js